var faqBlock = {
    $faqBlock: $('.faq-block'),
    $body: $('body'),
    $window: $(window),

    init: function() {
        var _this = this;

        if (!_this.$faqBlock.length) {
            return;
        }

        _this.$accordionBlock = _this.$faqBlock.find('.accordion-block');
        _this.$faqSections = _this.$faqBlock.find('.faq-section');
        _this.$stickyService = _this.$faqBlock.find('.sticky-service');
        _this.$listAnchors = _this.$stickyService.find('.list a');

        _this.listener();
        _this.checkFocus();
    },

    listener: function() {
        var _this = this;

        _this.$accordionBlock.on('accordionBlock:slideEnd', function() {
            _this.$body.trigger('sticky_kit:recalc');
        });

        _this.$window.on(
            'scroll resize',
            throttle(function() {
                _this.checkFocus();
            }, 300)
        );
    },

    checkFocus: function() {
        var _this = this;

        // Don't do if sticky nav is not visible
        if (_this.$stickyService.is(':hidden')) {
            return;
        }

        var $focused = _this.getFocusedSection();
        _this.setActiveAnchorList($focused);
    },

    getFocusedSection: function() {
        var _this = this;

        return _this.$faqSections
            .filter(function() {
                var rect = this.getBoundingClientRect();

                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= $(window).height() &&
                    rect.right <= $(window).width()
                );
            })
            .first();
    },

    setActiveAnchorList: function($focusedEl) {
        var _this = this;
        var id = $focusedEl.attr('id');

        _this.$listAnchors
            .removeClass('active')
            .filter(function() {
                return (
                    $(this)
                        .attr('href')
                        .replace('#', '') === id
                );
            })
            .addClass('active');
    }
};
